import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/kit";
import { ThankButton } from "@/components/ThankButton";
import { toast } from "sonner";

const monthKey = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "long", year: "numeric" });

const HugCard = ({ h, onThanked }) => (
  <div className="mm-card p-4 flex gap-3 items-start mm-fade-up" data-testid={`hug-card-${h.id}`}>
    <div className="w-11 h-11 shrink-0 rounded-full flex items-center justify-center text-2xl bg-[#F28FAD22]" aria-hidden>🤗</div>
    <div className="min-w-0">
      <div className="font-semibold break-words">{h.supporter_name}</div>
      <div className="text-sm text-mm-muted">Hugged you for your {h.milestone}-day skill streak · {new Date(h.at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}</div>
      {h.note_id && <div className="mt-2"><ThankButton noteId={h.note_id} index={0} name={h.supporter_name} done={h.thanked} label="Thank you for the hug 💜" onDone={() => onThanked(h.id)} /></div>}
    </div>
  </div>
);

export default function Hugs() {
  const [hugs, setHugs] = useState(null);
  useEffect(() => { api.get("/streak-hugs").then((r) => setHugs(r.data)).catch((e) => { setHugs([]); toast.error(errMsg(e)); }); }, []);
  if (!hugs) return <Spinner />;
  const groups = hugs.reduce((acc, h) => { const k = monthKey(h.at); (acc[k] = acc[k] || []).push(h); return acc; }, {});
  const thanked = (id) => setHugs((l) => l.map((x) => (x.id === id ? { ...x, thanked: true } : x)));
  return (
    <div className="max-w-3xl" data-testid="hugs-page">
      <PageHeader back title="My Hugs" subtitle={hugs.length ? `${hugs.length} hug${hugs.length === 1 ? "" : "s"} from people cheering you on` : "A keepsake of every hug your supporters send for your skill streaks."} />
      {!hugs.length && (
        <div className="mm-card p-8 text-center" data-testid="hugs-empty">
          <div className="text-4xl" aria-hidden>🌱</div>
          <p className="mt-2 font-semibold">No hugs yet</p>
          <p className="text-sm text-mm-muted mt-1">Try your Skill of the Day 5 days in a row and your supporters can send you a hug.</p>
          <Link to="/" className="mm-btn mt-4 inline-flex" data-testid="hugs-home-cta">See today's skill</Link>
        </div>
      )}
      {Object.entries(groups).map(([month, list]) => (
        <section key={month} className="mb-8" data-testid={`hugs-month-${month.replace(/\s+/g, "-").toLowerCase()}`}>
          <h2 className="text-base md:text-lg font-bold mb-3">{month} <span className="text-mm-muted font-normal text-sm">· {list.length} hug{list.length === 1 ? "" : "s"}</span></h2>
          <div className="grid sm:grid-cols-2 gap-3">{list.map((h) => <HugCard key={h.id} h={h} onThanked={thanked} />)}</div>
        </section>
      ))}
    </div>
  );
}
